export default class CollapsibleContent {
  constructor(node) {
    this.element = node;
    this.collapsibleTriggerElements = this.element.querySelectorAll(".js-collapsible-trigger");

    this.initialize();
  }

  initialize() {
    this.collapsibleTriggerElements.forEach((collapsibleTriggerElement) => {
      collapsibleTriggerElement.addEventListener("change", (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.displayContent(name, value);
      });
    });
  }

  displayContent(name, value) {
    const elements = this.element.querySelectorAll(`[data-triggerable-input='${name}']`);

    elements.forEach((element) => {
      element.classList.toggle("expanded", element.matches(`[data-triggerable-values~='${value}']`));
    });
  }
}
